import _defineProperty from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  display: block;\n  grid-area: ", ";\n  box-sizing: border-box;\n  width: 100%;\n\n  padding-inline-start: 2px; /* Make sure the cursor is visible next to outline on focus */\n  padding-inline-end: var(--text-field-extension-indent);\n  padding-block-start: var(--text-field-indent-block-start);\n  padding-block-end: var(--text-field-indent-block-end);\n  margin-block-end: 1px; /* Adds the space for the interaction bar */\n\n  transition: color 0.25s var(", ");\n\n  &:hover {\n    color: var(", ");\n  }\n\n  &:focus {\n    color: var(", ");\n  }\n\n  &:disabled {\n    color: var(", ");\n  }\n\n  &:invalid {\n    box-shadow: none; /* Removes outline in Firefox */\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      ", "\n\n      &", " {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n      }\n\n      /* Trigger interactionBar when preceding elements child received focus */\n      *:focus-within ~ &", " {\n        ", "\n      }\n\n      /* Trigger interactionBar when preceding elements child received hover */\n      *:hover ~ &", " {\n        ", "\n      }\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      &:hover {\n        color: var(", ");\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  position: relative;\n\n  display: inline-block;\n  grid-area: ", ";\n  box-sizing: content-box;\n  min-width: 24px;\n  max-height: 25px; /* includes 1px for the bottom border */\n  padding-block-start: var(--text-field-indent-block-start);\n  padding-block-end: var(--text-field-indent-block-end);\n  padding-inline-start: var(--text-field-extension-indent);\n  padding-inline-end: var(--text-field-extension-indent);\n\n  text-align: end;\n\n  cursor: ", ";\n\n  user-select: none;\n\n  ", "\n\n  &:disabled {\n    color: var(", ");\n  }\n\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      ", "\n\n      &", " {\n        grid-area: ", ";\n        align-self: end;\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  /** \n   * This container is only here to give context to some CSS selectors like\n   *':focus-within' and '::after'.\n   */\n  display: contents;\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  --text-field-indent-block-start: var(\n    ", "\n  );\n  --text-field-indent-block-end: var(\n    ", "\n  );\n  --text-field-extension-indent: var(\n    ", "\n  );\n\n  display: grid;\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n\n  color: var(", ");\n  ", "\n  ", "\n  \n  background-color: transparent;\n  border: none;\n  border-radius: 0;\n\n  appearance: none;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { injectTypography } from '../../utils/injectTypography';
import { injectInteractionBar, injectInteractionBarActiveStyles, injectInteractionBarHoverStyles, interactionBarSelector } from '../../utils/injectInteractionBar';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { getEasing } from '../../utils/getEasing';
import { injectOSXFontSmoothing } from '../../utils/injectOSXFontSmoothing';
var GridAreas;

(function (GridAreas) {
  GridAreas["label"] = "Label";
  GridAreas["input"] = "Input";
  GridAreas["extensionEnd"] = "ExtensionEnd";
})(GridAreas || (GridAreas = {}));

function injectInputLayout(props) {
  var layout = {
    gridTemplateAreas: "\n      \"".concat(GridAreas.label, "\"\n      \"").concat(GridAreas.input, "\"\n    ")
  };

  if (props.hasExtensionEnd) {
    layout.gridTemplateAreas = "\n      \"".concat(GridAreas.label, " X\"\n      \"").concat(GridAreas.input, " ").concat(GridAreas.extensionEnd, "\"\n    ");
    layout.gridTemplateColumns = '1fr auto';
  }

  return layout;
}

var getStateColor = function getStateColor(_ref, state) {
  var theme = _ref.theme,
      disabled = _ref.disabled,
      invalid = _ref.invalid,
      readOnly = _ref.readOnly,
      filled = _ref.filled;
  var key = state || filled && 'filled' || disabled && 'disabled' || invalid && 'invalid' || readOnly && 'readOnly' || 'default';
  return {
    default: theme.colors.interaction.secondary.default,
    disabled: theme.colors.interaction.secondary.disabled,
    invalid: theme.colors.ui.error,
    readOnly: theme.colors.interaction.secondary.readonly,
    hover: theme.colors.interaction.secondary.hover,
    focus: theme.colors.interaction.secondary.focus,
    filled: theme.colors.interaction.secondary.filled
  }[key];
};
/**
 * https://styled-components.com/docs/api#shouldforwardprop
 *
 * @param {(string | number)} prop
 * @param {((prop: string | number) => boolean)} defaultValidatorFn
 * @returns
 */


function filterProps(prop, defaultValidatorFn) {
  var list = ['disabled'];
  return !list.includes(prop) && defaultValidatorFn(prop);
}

var commonStyles = function commonStyles(props) {
  return css(_templateObject(), getStateColor, injectTypography(props, 'copy1'), injectOSXFontSmoothing(true));
};

export var StyledTextField = styled.div(_templateObject2(), injectSpacing('margin'));
export var StyledTextFieldLayout = styled.div.withConfig({
  shouldForwardProp: filterProps
})(_templateObject3(), function (props) {
  return props.theme.responsive.spacing.xxs;
}, function (props) {
  return props.theme.responsive.spacing.xs;
}, function (props) {
  return props.theme.responsive.spacing.xs;
}, injectInputLayout);
export var StyledInputWrapper = styled.div.withConfig({
  shouldForwardProp: filterProps
})(_templateObject4(), function (props) {
  return !props.readOnly && css(_templateObject5(), injectInteractionBar(props), interactionBarSelector, GridAreas.input);
});
export var StyledExtension = styled.div(_templateObject6(), commonStyles, GridAreas.extensionEnd, function (props) {
  if (props.disabled) {
    return 'not-allowed';
  }

  if (props.onClick) {
    return 'pointer';
  }

  return false;
}, function (props) {
  return props.onClick && css(_templateObject7(), getStateColor(props, 'hover'));
}, function (props) {
  return getStateColor(props, 'disabled');
}, function (props) {
  return !props.readOnly && css(_templateObject8(), injectInteractionBar(_objectSpread({}, props, {
    static: !props.onClick
  })), interactionBarSelector, interactionBarSelector, injectInteractionBarActiveStyles, interactionBarSelector, injectInteractionBarHoverStyles);
});
export var StyledInput = styled.input(_templateObject9(), commonStyles, GridAreas.input, getEasing, function (props) {
  return getStateColor(props, 'hover');
}, function (props) {
  return getStateColor(props, 'focus');
}, function (props) {
  return getStateColor(props, 'disabled');
});